import React, { FC } from 'react';
import { hasChildrenToRender } from '../../../../utils/react/children';
import styles from './EditImagesAndVideoSection.scss';
import { IOuter } from './EditImagesAndVideoSection.types';

export const EditImagesAndVideoSection: FC<IOuter> = ({ dataHook, children }) => {
  if (!hasChildrenToRender(children)) {
    return null;
  }

  return (
    <div className={styles.editWrapper} data-hook={dataHook}>
      <div className={styles.editItemsHolder}>{children}</div>
    </div>
  );
};
